import { Links } from "../../../content";
import { ContainerAtom } from "../../atoms";
import { ILink } from "../../interfaces/Link";
import styles from "./styles.module.scss";

export function SubNavMolecule() {
  if (process.env.REACT_APP_VERWERKINGSOVERZICHT !== "true") return null;

  const links: ILink[] = [Links.subnav.documentenlijst, Links.subnav.verwerkingsoverzicht].map((link) => ({
    ...link,
    selected: window.location.hash === link.href,
  }));

  return (
    <nav className={styles.subnav} aria-label="Submenu">
      <ContainerAtom centeredHorizontal>
        <ul className={styles.subnav__list}>
          {links.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                title={link.title}
                className={
                  link.selected ? `${styles.subnav__link} ${styles["subnav__link--selected"]}` : styles.subnav__link
                }
                aria-current={link.selected ? "page" : undefined}
              >
                {link.text}
              </a>
            </li>
          ))}
        </ul>
      </ContainerAtom>
    </nav>
  );
}
